import CityPageTemplate from "../city-template/CityPageTemplate";
import { bathConfig } from "./data";

export default function BathPage() {
  return <CityPageTemplate config={bathConfig} />;
}